import { Input, Label } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkTableRow, getTransparent } from "../../Utils/otherFunctions";

const FilterTanggal = ({ setSelectedFilterTanggal }) => {
  const { themeContext } = useThemeContext();

  return (
    <>
      <Label className="bg-transparent">Tanggal</Label>
      <Input
        type="date"
        onChange={(e) => setSelectedFilterTanggal(e.target.value)}
      />
    </>
  );
};

export default FilterTanggal;
